import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class PreviewZoomMessage extends WebViewMessage {
  public constructor(public zoom: number) {
    super(MessageType.PreviewZoom);
  }
}
